// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resume-container {
  font-family: 'Courier New', Courier;
  display: flex;
  justify-content: space-between;
  padding: 0 3%;
  font-size: 90%;
}

.column {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(65% - 1.5%);
  margin-right: 1.5%;
}

.column:last-child {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(35% - 1.5%);
  margin-right: 0;
  border-right: none;
}

ul {
  list-style: none;
  padding: 0;
}

h2 {
  margin-top: 20px;
  color: rgb(184, 152, 45);
  font-size: 28px;
  position: relative;
  border-bottom: 1px double #4e5355;
  margin-bottom: 2%;
  margin-left: 1%;
}

.section {
  text-align: left;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;
}

.btn:hover {
  background-color: #0056b3;
}


/*------------------------------------------------------------- EXPERIENCE -------------------------------------------------------------*/
.Experience h3 {
  color: rgb(45, 184, 154);
  font-size: 24px;
  margin-top: 1em;
  position: relative;
}

.subexperience {
  margin-left: 3em;
  margin-right: 3em;
}

.Experience p {
  margin: 10px 0;
  padding-left: 15px;
}


.Experience ul {
  padding-left: 5%;
}

.Experience ul li {
  position: relative;
  padding-left: 10px;
}

.Experience ul li::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 2px;
  width: 2px;
  height: 100%;
  background-color: #404447;
}

/*------------------------------------------------------------- SKILLS -------------------------------------------------------------*/

.skill-buttons {
  margin-top: 3%;
  justify-content: space-evenly;
  display: flex;
  flex-wrap: wrap;
}

.skill-buttons button {
  margin-right: 10px;
  margin-bottom: 20px;
  padding: 10px 10px;
  cursor: pointer;
  background-color: #303335;
  color: rgb(223, 221, 217);
  width: 120px;
  height: 40px;
  border-radius: 3px;
  border: 2px solid rgb(34, 31, 24);
}

.skill-buttons button.selected {
  background-color: rgb(39, 117, 100);
}

.progress-bars {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  color: #b4bdc0;
  margin-right: 5%;
  margin-left: 5%;
}


.progress-bar {
  margin-bottom: 20px;
}

.progress-bar progress {
  width: 100%;
  height: 5%;
  border: none;
}

.progress-bar progress {
  width: 100%;
  height: 20px;
  border: none;
}

.progress-bar progress::-webkit-progress-value {
  background: rgb(46, 139, 119);
}

.progress-bar progress::-webkit-progress-bar {
  background: #33383b;
}

.progress-bar progress::-moz-progress-bar {
  background: rgb(39, 117, 100);
}

.progress-bar progress {
  background: #33383b;
  ;
}

/*------------------------------------------------------------- EDUCATION -------------------------------------------------------------*/

.education-container {
  display: flex;
  align-items: center;
  padding: 10px;
}

.education_name {
  font-size: 20px;
  color: rgb(45, 184, 154);
  margin-bottom: 10px;
}

.university-logo {
  width: 6vw;
  height: auto;
  margin-right: 15px;
}

.education-info {
  flex-grow: 1;
}

/*------------------------------------------------------------- FURTHER TRAINING -------------------------------------------------------------*/

.course {
  position: relative;
  padding-left: 2em;
  margin-bottom: 20px;
}


.course h3 {
  color: rgb(45, 184, 154);
  font-size: 22px;
  margin-top: 1em;
  position: relative;
}

.course p {
  margin: 10px 0;
  padding-left: 15px;
}

.course ul li {
  position: relative;
  padding-left: 35px;
}

.course ul li::before {
  content: "";
  position: absolute;
  left: 25px;
  top: 2px;
  width: 2px;
  height: 100%;
  background-color: #404447;
}

/*------------------------------------------------------------- VOLUNTEERING -------------------------------------------------------------*/

.volunteering-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.volunteering-name {
  font-size: 20px;
  color: rgb(45, 184, 154);
  margin-bottom: 10px;
}

.volunteering-logo {
  width: 5vw;
  margin-right: 3%;
  margin-left: 4%;
}

.volunteer-logo {
  width: 5vw;
  height: 5vw;
  margin-right: 3%;
  margin-left: 4%;
}

.volunteering-info {
  flex-grow: 1;
}

.volunteering-info p {
  margin: 10px 0;
}


/*------------------------------------------------------------- LANGUAGES -------------------------------------------------------------*/

.language {
  margin-bottom: 20px;
  margin-left: 4%;
  color: rgb(45, 184, 154);
}

.language-buttons {
  display: flex;
  justify-content: space-evenly;
  margin-top: 10px;
  background-color: transparent;
  color: #ffffff;
}

.language-buttons button {
  padding: 1% 3%;
  cursor: pointer;
  border-radius: 1vb;
  border: none;
  background-color: #303335;
}

.language-buttons .current-level {
  border: 2px solid rgb(45, 184, 154);
}


/*------------------------------------------------------------- PARTICIPATION -------------------------------------------------------------*/
.Participation ul {
  padding-left: 20px;
  margin-left: 4%;
  margin-bottom: 30px;
}

.Participation li {
  list-style-type: none;
  margin-bottom: 8px;
}


@media (max-width: 1050px) {
  .resume-container {
    flex-direction: column;
    align-items: stretch;
  }

  .column {
    flex: 0 0 100%;
    margin-right: 0;
    border-right: none;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 16px;
  }

  .Experience h3,
  .course h3,
  .volunteering-name,
  .education_name {
    font-size: 15px;
  }

  p,
  ul {
    font-size: 12px;
  }

  .skill-buttons button {
    padding: 5px 5px;
    width: 90px;
    height: 30px;
    font-size: 80%;
  }

  .university-logo,
  .volunteering-logo {
    width: 12vw;
  }

  .language-buttons button {
    padding: 1% 2%;
    font-size: 75%;
  }
}


/*------------------------------------------------------------- LIGHT THEME -------------------------------------------------------------*/


[data-theme='light'] .resume-container {
  background-color: #ebeaea;
}

[data-theme='light'] h2 {
  color: #aa9e6f;
}

[data-theme='light'] .progress-bar progress::-webkit-progress-value {
  background: #aa9e6f;
}

[data-theme='light'] .progress-bar progress::-webkit-progress-bar {
  background: #cac9c9;
}

[data-theme='light'] .Experience h3,
[data-theme='light'] .education_name,
[data-theme='light'] .course h3,
[data-theme='light'] .volunteering-name,
[data-theme='light'] .language {
  color: #919191;
}

[data-theme='light'] .language-buttons .current-level {
  border: 3px solid rgb(136, 111, 30);
  background-color: #b9bbbd;
}

[data-theme='light'] .language-buttons button {
  background-color: #cac9c9;
}

[data-theme='light'] .language-buttons {
  color: rgb(0, 0, 0);
  ;
}

[data-theme='light'] .skill-buttons button {
  background: #cac9c9;
  color: rgb(0, 0, 0);
  border: 2px solid rgb(75, 72, 66);
}

[data-theme='light'] .skill-buttons button.selected {
  background-color: #979da0;
}

[data-theme='light'] .progress-bars {
  color: #707577;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Resume/Resume.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,yIAAyI;AACzI;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,qIAAqI;;AAErI;EACE,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;;AAErB;;AAEA,wIAAwI;;AAExI;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,+IAA+I;;AAE/I;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,2IAA2I;;AAE3I;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;AAGA,wIAAwI;;AAExI;EACE,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;;AAGA,4IAA4I;AAC5I;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;;AAGA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;AACF;;;AAGA,0IAA0I;;;AAG1I;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".resume-container {\n  font-family: 'Courier New', Courier;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 3%;\n  font-size: 90%;\n}\n\n.column {\n  flex: 0 0 calc(65% - 1.5%);\n  margin-right: 1.5%;\n}\n\n.column:last-child {\n  flex: 0 0 calc(35% - 1.5%);\n  margin-right: 0;\n  border-right: none;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n}\n\nh2 {\n  margin-top: 20px;\n  color: rgb(184, 152, 45);\n  font-size: 28px;\n  position: relative;\n  border-bottom: 1px double #4e5355;\n  margin-bottom: 2%;\n  margin-left: 1%;\n}\n\n.section {\n  text-align: left;\n}\n\n.btn {\n  display: inline-block;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  text-decoration: none;\n  border-radius: 5px;\n}\n\n.btn:hover {\n  background-color: #0056b3;\n}\n\n\n/*------------------------------------------------------------- EXPERIENCE -------------------------------------------------------------*/\n.Experience h3 {\n  color: rgb(45, 184, 154);\n  font-size: 24px;\n  margin-top: 1em;\n  position: relative;\n}\n\n.subexperience {\n  margin-left: 3em;\n  margin-right: 3em;\n}\n\n.Experience p {\n  margin: 10px 0;\n  padding-left: 15px;\n}\n\n\n.Experience ul {\n  padding-left: 5%;\n}\n\n.Experience ul li {\n  position: relative;\n  padding-left: 10px;\n}\n\n.Experience ul li::before {\n  content: \"\";\n  position: absolute;\n  left: -15px;\n  top: 2px;\n  width: 2px;\n  height: 100%;\n  background-color: #404447;\n}\n\n/*------------------------------------------------------------- SKILLS -------------------------------------------------------------*/\n\n.skill-buttons {\n  margin-top: 3%;\n  justify-content: space-evenly;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.skill-buttons button {\n  margin-right: 10px;\n  margin-bottom: 20px;\n  padding: 10px 10px;\n  cursor: pointer;\n  background-color: #303335;\n  color: rgb(223, 221, 217);\n  width: 120px;\n  height: 40px;\n  border-radius: 3px;\n  border: 2px solid rgb(34, 31, 24);\n}\n\n.skill-buttons button.selected {\n  background-color: rgb(39, 117, 100);\n}\n\n.progress-bars {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  color: #b4bdc0;\n  margin-right: 5%;\n  margin-left: 5%;\n}\n\n\n.progress-bar {\n  margin-bottom: 20px;\n}\n\n.progress-bar progress {\n  width: 100%;\n  height: 5%;\n  border: none;\n}\n\n.progress-bar progress {\n  width: 100%;\n  height: 20px;\n  border: none;\n}\n\n.progress-bar progress::-webkit-progress-value {\n  background: rgb(46, 139, 119);\n}\n\n.progress-bar progress::-webkit-progress-bar {\n  background: #33383b;\n}\n\n.progress-bar progress::-moz-progress-bar {\n  background: rgb(39, 117, 100);\n}\n\n.progress-bar progress {\n  background: #33383b;\n  ;\n}\n\n/*------------------------------------------------------------- EDUCATION -------------------------------------------------------------*/\n\n.education-container {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n}\n\n.education_name {\n  font-size: 20px;\n  color: rgb(45, 184, 154);\n  margin-bottom: 10px;\n}\n\n.university-logo {\n  width: 6vw;\n  height: auto;\n  margin-right: 15px;\n}\n\n.education-info {\n  flex-grow: 1;\n}\n\n/*------------------------------------------------------------- FURTHER TRAINING -------------------------------------------------------------*/\n\n.course {\n  position: relative;\n  padding-left: 2em;\n  margin-bottom: 20px;\n}\n\n\n.course h3 {\n  color: rgb(45, 184, 154);\n  font-size: 22px;\n  margin-top: 1em;\n  position: relative;\n}\n\n.course p {\n  margin: 10px 0;\n  padding-left: 15px;\n}\n\n.course ul li {\n  position: relative;\n  padding-left: 35px;\n}\n\n.course ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 25px;\n  top: 2px;\n  width: 2px;\n  height: 100%;\n  background-color: #404447;\n}\n\n/*------------------------------------------------------------- VOLUNTEERING -------------------------------------------------------------*/\n\n.volunteering-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.volunteering-name {\n  font-size: 20px;\n  color: rgb(45, 184, 154);\n  margin-bottom: 10px;\n}\n\n.volunteering-logo {\n  width: 5vw;\n  margin-right: 3%;\n  margin-left: 4%;\n}\n\n.volunteer-logo {\n  width: 5vw;\n  height: 5vw;\n  margin-right: 3%;\n  margin-left: 4%;\n}\n\n.volunteering-info {\n  flex-grow: 1;\n}\n\n.volunteering-info p {\n  margin: 10px 0;\n}\n\n\n/*------------------------------------------------------------- LANGUAGES -------------------------------------------------------------*/\n\n.language {\n  margin-bottom: 20px;\n  margin-left: 4%;\n  color: rgb(45, 184, 154);\n}\n\n.language-buttons {\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 10px;\n  background-color: transparent;\n  color: #ffffff;\n}\n\n.language-buttons button {\n  padding: 1% 3%;\n  cursor: pointer;\n  border-radius: 1vb;\n  border: none;\n  background-color: #303335;\n}\n\n.language-buttons .current-level {\n  border: 2px solid rgb(45, 184, 154);\n}\n\n\n/*------------------------------------------------------------- PARTICIPATION -------------------------------------------------------------*/\n.Participation ul {\n  padding-left: 20px;\n  margin-left: 4%;\n  margin-bottom: 30px;\n}\n\n.Participation li {\n  list-style-type: none;\n  margin-bottom: 8px;\n}\n\n\n@media (max-width: 1050px) {\n  .resume-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .column {\n    flex: 0 0 100%;\n    margin-right: 0;\n    border-right: none;\n    margin-bottom: 20px;\n  }\n\n  h2 {\n    font-size: 16px;\n  }\n\n  .Experience h3,\n  .course h3,\n  .volunteering-name,\n  .education_name {\n    font-size: 15px;\n  }\n\n  p,\n  ul {\n    font-size: 12px;\n  }\n\n  .skill-buttons button {\n    padding: 5px 5px;\n    width: 90px;\n    height: 30px;\n    font-size: 80%;\n  }\n\n  .university-logo,\n  .volunteering-logo {\n    width: 12vw;\n  }\n\n  .language-buttons button {\n    padding: 1% 2%;\n    font-size: 75%;\n  }\n}\n\n\n/*------------------------------------------------------------- LIGHT THEME -------------------------------------------------------------*/\n\n\n[data-theme='light'] .resume-container {\n  background-color: #ebeaea;\n}\n\n[data-theme='light'] h2 {\n  color: #aa9e6f;\n}\n\n[data-theme='light'] .progress-bar progress::-webkit-progress-value {\n  background: #aa9e6f;\n}\n\n[data-theme='light'] .progress-bar progress::-webkit-progress-bar {\n  background: #cac9c9;\n}\n\n[data-theme='light'] .Experience h3,\n[data-theme='light'] .education_name,\n[data-theme='light'] .course h3,\n[data-theme='light'] .volunteering-name,\n[data-theme='light'] .language {\n  color: #919191;\n}\n\n[data-theme='light'] .language-buttons .current-level {\n  border: 3px solid rgb(136, 111, 30);\n  background-color: #b9bbbd;\n}\n\n[data-theme='light'] .language-buttons button {\n  background-color: #cac9c9;\n}\n\n[data-theme='light'] .language-buttons {\n  color: rgb(0, 0, 0);\n  ;\n}\n\n[data-theme='light'] .skill-buttons button {\n  background: #cac9c9;\n  color: rgb(0, 0, 0);\n  border: 2px solid rgb(75, 72, 66);\n}\n\n[data-theme='light'] .skill-buttons button.selected {\n  background-color: #979da0;\n}\n\n[data-theme='light'] .progress-bars {\n  color: #707577;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
